<template>
  <v-col
    class="my-0 py-0"
    align="center"
    justify="center"
    :cols="colonna.dimensione"
    :style="{
      backgroundColor:
        workorder.tipo == 'intestazione'
          ? '#3f51b5'
          : workorder.colore_riga
          ? workorder.colore_riga
          : workorder.macchina_impegnata == 1
          ? '#EE9922'
          : colonna.colore_colonna,
    }"
  >
    <!-- Sezione per visualizzare l'oggetto -->
    <div
      :style="
        workorder.tipo == 'intestazione'
          ? { backgroundColor: '#3f51b5' }
          : workorder.colore_riga
          ? workorder.colore_riga
          : workorder.macchina_impegnata == 1
          ? { backgroundColor: '#EE9922' }
          : { backgroundColor: colonna.colore_colonna }
      "
      v-if="colonna.oggetto.filter((o) => o.validita == 1).length > 0"
    >
      <div v-if="workorder.tipo == 'intestazione'">
        <span
          :style="{
            color: '#FFFFFF',
            fontSize:
              colonna.oggetto.filter((o) => o.validita == 1)[0]
                .font_size_titolo + 'px',
            fontWeight: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_weight_titolo,
          }"
        >
          {{ colonna.oggetto.filter((o) => o.validita == 1)[0].testo }}
        </span>
      </div>
      <!-- Se l'oggetto è un bottone -->
      <div
        v-else-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'B'
        "
      >
        <!--pulsante generico-->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :height="
                colonna.oggetto.filter((o) => o.validita == 1)[0]
                  .font_size_icona +
                5 +
                'px'
              "
              :width="
                colonna.oggetto.filter((o) => o.validita == 1)[0]
                  .font_size_icona +
                5 +
                'px'
              "
              v-bind="attrs"
              v-on="on"
              class="button my-1"
              :color="
                colonna.oggetto.filter((o) => o.validita == 1)[0].colore_sfondo
              "
              @click="
                btnClick(
                  colonna.oggetto.filter((o) => o.validita == 1)[0].text,
                  workorder,
                  colonna.oggetto.filter((o) => o.validita == 1)[0].fields,
                  colonna.oggetto.filter((o) => o.validita == 1)[0].query
                )
              "
              :disabled="
                !chkAutorizzato(workorder, colonna, true) ||
                (workorder.ora_start == null &&
                  workorder.ora_stop == null &&
                  colonna.oggetto.filter((o) => o.validita == 1)[0].text ==
                    'Esecuzione Controllo')
              "
              tile
            >
              <v-icon
                :style="{
                  fontSize:
                    colonna.oggetto.filter((o) => o.validita == 1)[0]
                      .font_size_icona + 'px',
                }"
                :color="
                  colonna.oggetto.filter((o) => o.validita == 1)[0].colore_icona
                "
              >
                {{ colonna.oggetto.filter((o) => o.validita == 1)[0].icona }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{
            colonna.oggetto.filter((o) => o.validita == 1)[0].tooltip
          }}</span>
        </v-tooltip>
      </div>

      <!-- Se l'oggetto è un dato -->
      <v-card
        :class="`elevation-${colonna.elevata == 1 ? '2' : '0'}`"
        :style="{
          display: 'inline-block',
          background: workorder.colore_riga
            ? workorder.colore_riga
            : workorder.macchina_impegnata == 1
            ? '#EE9922'
            : colonna.colore_sfondo,
        }"
        v-else-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto ===
            'D' && chkAutorizzato(workorder, colonna, true)
        "
      >
        <!-- Titolo del dato -->
        <span
          v-if="hasIntestazione == 0"
          :style="{
            color: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_color_titolo,
            fontSize:
              colonna.oggetto.filter((o) => o.validita == 1)[0]
                .font_size_titolo + 'px',
            fontWeight: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_weight_titolo,
          }"
        >
          {{ colonna.oggetto.filter((o) => o.validita == 1)[0].tooltip }}
        </span>
        <br />
        <!-- Valore del dato -->
        <span
          :style="{
            color: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_color_dato,
            fontSize:
              colonna.oggetto.filter((o) => o.validita == 1)[0].font_size_dato +
              'px',
            fontWeight: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_weight_dato,
          }"
        >
          {{
            colonna.oggetto.filter((o) => o.validita == 1)[0].value ==
              "ora_start" ||
            colonna.oggetto.filter((o) => o.validita == 1)[0].value ==
              "ora_stop"
              ? formatData(
                  workorder[
                    colonna.oggetto.filter((o) => o.validita == 1)[0].value
                  ]
                )
              : workorder[
                  colonna.oggetto.filter((o) => o.validita == 1)[0].value
                ]
          }}
        </span>
      </v-card>

      <!-- Se l'oggetto è un checkbox -->
      <v-card
        :class="`elevation-${colonna.elevata == 1 ? '2' : '0'}`"
        :style="{
          display: 'inline-block',
          background: workorder.colore_riga
            ? workorder.colore_riga
            : workorder.macchina_impegnata == 1
            ? '#EE9922'
            : colonna.colore_colonna,
        }"
        v-else-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].text == 'v-checkbox'
        "
      >
        <!-- <span> -->
        <v-tooltip bottom style="diaplay: inline-block">
          <template v-slot:activator="{ on, attrs }">
            <div style="display: inline-block">
              <v-checkbox
                v-bind="attrs"
                v-on="on"
                v-model="
                  workorder[
                    colonna.oggetto.filter((o) => o.validita == 1)[0].value
                  ]
                "
              >
              </v-checkbox>
            </div>
          </template>
          <span>{{
            colonna.oggetto.filter((o) => o.validita == 1)[0].tooltip
          }}</span>
        </v-tooltip>
        <!-- </span> -->
      </v-card>

      <!-- Se l'oggetto è un'immagine -->
      <div
        v-else-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'I'
        "
        :style="{
          height: img_h + 'px !important',
          textAlign: 'center',
        }"
      >
        <img
          aspect-ratio="1"
          @click="showImageViewer"
          :lazy-src="workorder.immagine_preview"
          :src="workorder.immagine_preview"
          :style="{
            display: 'inline-block !important',
            height: img_h + 'px !important',
            width: img_w + 'px !important',
          }"
        />
      </div>

      <!-- Se l'oggetto è una notifica -->
      <v-card
        :class="`elevation-${colonna.elevata == 1 ? '2' : '0'}`"
        :style="{
          display: 'inline-block',
          background: colonna.oggetto.filter((o) => o.validita == 1)[0]
            .colore_sfondo,
        }"
        v-else-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto ===
            'N' && chkAutorizzato(workorder, colonna, false)
        "
      >
        <!-- Testo della notifica -->
        <span
          :style="{
            color: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_color_dato,
            fontSize:
              colonna.oggetto.filter((o) => o.validita == 1)[0].font_size_dato +
              'px',
            fontWeight: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_weight_dato,
          }"
        >
          {{ colonna.oggetto.filter((o) => o.validita == 1)[0].tooltip }}
        </span>
      </v-card>
    </div>

    <!-- Sezione per visualizzare una riga -->
    <v-container fluid v-else>
      <WorkorderLayoutRow
        @button_click="handleButtonClick"
        :gestione_team_enabled="gestione_team_enabled"
        :key="i"
        :riga="riga"
        v-for="(riga, i) in colonna.righe.filter((r) => r.validita == 1)"
        :workorder="workorder"
      />
    </v-container>

    <!-- Mini dialog per indicare gli impegni delle macchine -->
    <v-dialog v-model="dialog_impegni" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Impegni </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              dialog_impegni = false;
              conferma_dialog = false;
            "
            small
          >
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-3">
          <div style="display: inline-block; max-width: 500px">
            <span style="font-size: 15px">
              Questo Work Order non è disponibile per il carrello delle
              lavorazioni perché tutte le macchine ad esso associate risultano
              attualmente impegnate:
            </span>
          </div>
          <v-data-table
            :headers="headers_macchine_impegnate"
            hide-default-footer
            :items="items_macchine_impegnate"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Mini dialog per indicare il motivo per cui il WO non è selezionabile -->
    <v-dialog v-model="dialog_avviso" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Avviso </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              dialog_avviso = false;
              conferma_dialog = false;
            "
            small
          >
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-5">
          <span style="color: black; font-size: 17px">
            {{ workorder.messaggio_avvio }}
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Spazio per la snackbar e per i caspita di dialog -->
    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-col>
</template>
<script>
import moment from "moment/moment";
import ProduzioneColumnObject from "@/classes/ProduzioneColumnObject.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Workorder {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "autonoma", default_val: null },
      { nome: "cod_macchina", default_val: "" },
      { nome: "costo_orario", default_val: null },
      { nome: "data_acquisto", default_val: "" },
      { nome: "des_centrocosto", default_val: "" },
      { nome: "des_connessione", default_val: "" },
      { nome: "des_funzione", default_val: "" },
      { nome: "des_macchina", default_val: "" },
      { nome: "des_stato", default_val: "" },
      { nome: "des_reparto", default_val: "" },
      { nome: "fine_garanzia", default_val: "" },
      { nome: "flag_4_0", default_val: null },
      { nome: "id_centrocosto", default_val: null },
      { nome: "id_funzione", default_val: null },
      { nome: "id_macchina", default_val: null },
      { nome: "id_reparto", default_val: null },
      { nome: "id_stato", default_val: null },
      { nome: "id_tipo_get_macchina", default_val: null },
      { nome: "inizio_garanzia", default_val: "" },
      { nome: "macchina_img", default_val: "" },
      { nome: "marca", default_val: "" },
      { nome: "matricola", default_val: "" },
      { nome: "modello", default_val: "" },
      { nome: "multi_commessa", default_val: null },
      { nome: "on_line", default_val: null },
      { nome: "ore_disponibilita", default_val: null },
      { nome: "schedula", default_val: null },
      { nome: "specifiche", default_val: null },
      { nome: "tipo_connessione", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "WorkorderLayoutColumn",
  components: {
    WorkorderLayoutRow: () =>
      import("@/components/WorkorderLayout/WorkorderLayoutRow.vue"),

    SnackbarQV,
  },
  props: {
    colonna: { type: Object, default: new ProduzioneColumnObject() },
    gestione_team_enabled: { type: Number, default: 0 },
    workorder: { type: Object, default: () => {} },
    hasIntestazione: { type: Number, default: 0 },
  },
  data() {
    return {
      // Variabili d'appoggio
      graphArgs: {},
      graphDialog: false,
      id_articolo_sel: null,
      image_for_viewer: "",
      img_h: 0,
      img_w: 0,
      workorder_sel: new Workorder(),
      distintaItem: null,

      // Modal
      dialog_avviso: false,

      // Variabli for Stampa Modal and Part Program
      partProgramDialog: false,
      StampaEttichetaDialog: false,
      idMacchinaTemp: null,
      idArticoloTemp: null,
      id_commessa_dettaglio: null,
      uniqueKey: null,
      //End Variabli of Stampa Modal

      key_distinta_base: 0,
      dialogDistintaBase: false,
      dialog_impegni: false,
      loading: false,
      ubicazionePlacing: { id_magazzino_ubicazione: -1, path: "Nessuno" },
      qntPlacing: 0,
      placingDialog: false,
      avanzamento_packaging_visible: 0,
      conferma_nascondi: false,
      dialog_stampa: false,
      dialog_storico_prelievi: false,
      esecuzione_controllo_visible: 0,
      gestione_lotti_visible: 0,
      nascondi_wo_visible: 0,
      registrazione_visible: 0,
      start_stop_visible: 0,
      stato: true,
      subentro_visible: 0,
      overlay: false,
      visualizza_dialog_tabella_custom: false,
      visualizza_disegni_visible: 0,
      placingItem: { quantita: 0 },
      CommessaData: null,

      // Array
      items_macchine_impegnate: new Array(),
      items_storico_prelievo: [],
      items_info_wo: [],
      headers_macchine_impegnate: [
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Utente",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "data_inizio",
        },
      ],
      headers_storico: [
        { text: "Cod. Lotto", value: "cod_lotto" },
        { text: "Cod. Articolo", value: "cod_articolo" },
        { text: "Des: Articolo", value: "des_articolo" },
        { text: "Qta Impegno", value: "quantita_impegno" },
        { text: "Qta Prelevata", value: "quantita_prelevato" },
      ],
      rows: [{ pulsanti: [] }],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      async handler() {
        /* Se il mio WO ha un'immagine e se la mia colonna deve
         * renderizzare un oggetto immagine, calcolo larghezza
         * e altezza della miniatura. */
        if (
          this.workorder.immagine_preview &&
          this.colonna.oggetto.filter((o) => o.validita == 1).length > 0
        ) {
          this.img_h = await this.getMiniaturaH(
            this.workorder.immagine_preview,
            this.colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_size_icona
          );
          this.img_w = await this.getMiniaturaW(
            this.workorder.immagine_preview,
            this.colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_size_icona
          );
        }
      },
    },
  },
  methods: {
    async btnClick(text, item, codice_btn, query = -1) {
      if (
        this.workorder.avviabile !== undefined &&
        this.workorder.avviabile === 0
      ) {
        this.messaggio_avvio = this.workorder.messaggio_avvio;
        this.dialog_avviso = true;
        return;
      }

      if (this.workorder.messaggio_avvio !== undefined) {
        this.messaggio_avvio = this.workorder.messaggio_avvio;
      }

      /* Controllo che la macchina non sia già
       * impegnata per qualche altro Work Order. */
      if (
        item.macchina_impegnata == 1 &&
        item.multi_commessa == 0 &&
        this.workorder.avviabile !== 1
      ) {
        this.checkImpegnoMacchine(item);
        return;
      }

      this.$emit("button_click", text, item, codice_btn, query);
    },
    handleButtonClick(text, item, codice_btn, query) {
      this.$emit("button_click", text, item, codice_btn, query);
    },
    chkAutorizzato(workorder, colonna, default_res_val) {
      if (
        workorder.autorizzazioni &&
        colonna.oggetto.filter((o) => o.validita == 1).length > 0
      ) {
        return (
          workorder.autorizzazioni.filter(
            (a) =>
              a.field ==
                colonna.oggetto.filter((o) => o.validita == 1)[0].fields &&
              a.visible == 0
          ).length == 0
        );
      } else {
        return default_res_val;
      }
    },
    chkDisponibilita(arg) {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutentegenerale",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? arg.cod_commessa : "",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            let utilizzatore_macchina = null;
            res.data.workorders.workorder.forEach((w) => {
              /* Cerco il WO che mi interessa, se lo trovo
               * registro il suo utilizzatore_macchina. */
              if (
                w.id_commessa_dettaglio === arg.id_commessa_dettaglio &&
                arg.disponibile === 0
              ) {
                utilizzatore_macchina = w.utilizzatore_macchina;
              }
            });

            // Ritorno il nome dell'utilizzatore che ho trovato.
            return utilizzatore_macchina;
          } else {
            return "";
          }
        })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore tecnico nel controllo dell'impegno Work Order."
          );
          console.error(e);
          return "";
        });
    },
    checkImpegnoMacchine(arg) {
      const request = {
        controller: "MAGAZZINO",
        method: "POST",
        richiesta: {
          action: "checkworkorder",
          token: localStorage.user_token,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_macchine_impegnate = new Array();
            res.data.result.forEach((e) => {
              this.items_macchine_impegnate.push(Object.assign(e));
            });
            this.dialog_impegni = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    async confirmPlacing() {
      var movimento = {
        id_magazzino_movimenti: -1,
        id_articolo: this.placingItem.id_articolo,
        id_ubicazione: this.ubicazionePlacing.id_magazzino_ubicazione,
        id_commessa: this.placingItem.id_commessa,
        quantita: this.qntPlacing,
        cod_articolo: this.placingItem.cod_articolo,
        numero_seriale: -1,
        id_controllo: 0,
      };
      this.loading = true;
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setmovimentimagazzino",
          token: localStorage.user_token,
          movimento: [movimento],
        },
      };
      await this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Placing Salvato");
            this.loading = false;
          } else {
            this.$refs.SnackbarQV.print("error", "Placing non Salvato");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          if (err) {
            this.$refs.SnackbarQV.print("error", "Placing non Salvato");
          }
        });
      this.placingDialog = false;
    },
    closePlacing() {
      this.placingDialog = false;
    },
    closeStoricoPrelievi() {
      this.dialog_storico_prelievi = false;
      this.performPopQuery(this.createStdQueryArr(this.workorder));
    },
    createStdQueryArr(arg_obj) {
      const arr_params = [{ name: "id_utente", value: localStorage.id }];

      for (let field in arg_obj) {
        if (field != "autorizzazioni" && field != "immagine_preview") {
          arr_params.push({
            name: field,
            value: arg_obj[field],
          });
        }
      }

      return arr_params;
    },
    fermaLavorazioneTeam(arg) {
      /* Chiedo le persone che hanno le competenze per lavorare
       * su questa fase; alcune di loro possono avere già uno
       * start / stop. In base ai dati, andrò a comunicare al BE
       * dei nuovi stop sugli operatori debiti. */
      const request_get = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessatempisquadra",
          token: localStorage.user_token,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
        },
      };

      return this.$store
        .dispatch("api", request_get)
        .then((res) => {
          if (res.status === 200) {
            /* Mi metto da parte solo gli operatori già presenti sul
             * DB che abbiano un'ora di start ma non una di stop. */
            const arr_tmp = new Array();
            res.data.squadra.forEach((e) => {
              if (
                e.id_commessa_tempi_squadra != -1 &&
                e.ora_inizio != null &&
                e.ora_fine == null
              ) {
                e.ora_fine = new moment().format("YYYY-MM-DD HH:mm:ss");
                arr_tmp.push(Object.assign({}, e));
              }
            });

            /* Se arr_tmp era vuoto ritorno true, e fine; se
             * invece era popolato faccio ancora la chiamata di
             * set per modificare le ore di stop degli operatori. */
            if (arr_tmp.length > 0) {
              const request_set = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                  action: "setcommessatempisquadra",
                  token: localStorage.user_token,
                  squadra: arr_tmp,
                },
              };

              return this.$store
                .dispatch("api", request_set)
                .then((res) => {
                  if (res.status === 200) {
                    return true;
                  } else {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );

                    return false;
                  }
                })
                .catch((e) => {
                  console.error(e);
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                  );

                  return false;
                });
            } else {
              // Se arr_tmp era vuoto ritorno true, e fine;
              return true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    formatData(arg) {
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        return strRes;
      }
    },
    formattaData(arg) {
      const res = `${arg.substr(8, 2)}/${arg.substr(5, 2)}/${arg.substr(
        0,
        4
      )} ${arg.substr(11, 5)}`;
      return res;
    },
    getMiniaturaH(arg_img, arg_max) {
      return new Promise(function (resolve) {
        const img_tmp = new Image();
        img_tmp.src = arg_img;

        img_tmp.onload = function () {
          // Se i valori sono spanati ritorno 0.
          if (img_tmp.naturalHeight == null || img_tmp.naturalHeight == "") {
            console.warn("L'immagine ha dimensioni nulle.");
            resolve(0);
          }

          const res = new Object();

          // Se l'immagine eccede le dimensioni della miniatura...
          if (
            img_tmp.naturalWidth > arg_max ||
            img_tmp.naturalHeight > arg_max
          ) {
            // Se è larga o quadrata...
            if (
              img_tmp.naturalWidth > img_tmp.naturalHeight ||
              img_tmp.naturalWidth === img_tmp.naturalHeight
            ) {
              res.width = arg_max;
              res.height =
                (res.width * img_tmp.naturalHeight) / img_tmp.naturalWidth;
              resolve(res.height);
            } else if (img_tmp.height > img_tmp.naturalWidth) {
              // Se invece è alta...
              resolve(arg_max);
            }
          } else {
            // Se l'immagine è più piccola della miniatura...
            resolve(img_tmp.naturalHeight);
          }
        };
      });
    },
    async getMiniaturaW(arg_img, arg_max) {
      return new Promise(function (resolve) {
        const img_tmp = new Image();
        img_tmp.src = arg_img;

        img_tmp.onload = function () {
          // Se i valori sono spanati ritorno 0.
          if (img_tmp.naturalWidth == null || img_tmp.naturalWidth == "") {
            console.warn("L'immagine ha dimensioni nulle.");
            resolve(0);
          }

          const res = new Object();

          // Se l'immagine eccede le dimensioni della miniatura...
          if (
            img_tmp.naturalWidth > arg_max ||
            img_tmp.naturalHeight > arg_max
          ) {
            // Se è larga o quadrata...
            if (
              img_tmp.naturalWidth > img_tmp.naturalHeight ||
              img_tmp.naturalWidth === img_tmp.naturalHeight
            ) {
              resolve(arg_max);
            } else if (img_tmp.height > img_tmp.naturalWidth) {
              // Se invece è alta...
              res.height = arg_max;
              res.width =
                (res.height * img_tmp.naturalWidth) / img_tmp.naturalHeight;
              resolve(res.width);
            }
          } else {
            // Se l'immagine è più piccola della miniatura...
            resolve(img_tmp.naturalWidth);
          }
        };
      });
    },
    getRelazioniModuli(arg_id_commessa_dettaglio, arg_cod) {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          codice: arg_cod,
          id_riferimento: arg_id_commessa_dettaglio,
          id_personale: localStorage.id,
          riferimento: "commessa_dettaglio",
          modulo: "questionario",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result.dati.length > 0) {
              let object = {
                id_relazione: res.data.result.dati[0].id_relazione,
                id_modulo: res.data.result.dati[0].id_start,
                exec: res.data.result.dati[0]._exec,
                id_relazione_log: res.data.result.dati[0].id_relazione_log,
              };
              return object;
            } else {
              return {
                exec: "N",
              };
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    performPopQuery(arr_parametri) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryevent",
          token: localStorage.user_token,
          tipo: "post",
          codice: this.$store.state.stack_query.pop(),
          params: arr_parametri,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return true;
          } else {
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    performPreQuery(arg_cod_pulsante, arg_parametri) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryevent",
          token: localStorage.user_token,
          tipo: "pre",
          codice: arg_cod_pulsante,
          params: arg_parametri,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$store.state.stack_query.push(arg_cod_pulsante);
            return true;
          } else {
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    selectPlacingUbicazione() {
      console.log("test");
    },
    sendPartProgram() {
      this.$refs.GestioneFasiValori.getPpJSON();
    },
    setCommessaTempi(commessa, start_stop, arg_nascondi, arg_emit, arg_dialog) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessatempi",
          token: localStorage.getItem("user_token"),
          id_commessa: commessa.id_commessa,
          id_commessa_dettaglio: commessa.id_commessa_dettaglio,
          id_macchina: commessa.id_macchina,
          start: start_stop,
          id_causale: 55,
        },
      };

      const that = this;
      return new Promise((resolve) => {
        that.$store.dispatch("api", request).then(() => {
          that.overlay = false;
          if (start_stop == 0) {
            if (arg_emit === "on") {
              that.$emit("click_stop", commessa, arg_nascondi, arg_dialog);
            }
          } else {
            if (arg_emit === "on") {
              that.$emit("click_start");
            }
          }
          resolve();
        });
      });
    },
    showImageViewer() {
      /* Se la mia variabile locale per i dati dell'allegato è
       * già valorizzata, carico questi dati. Se invece non è valorizzata
       * ma sono stato in grado di cliccare sulla miniatura, vuol dire che
       * in passato ho salvato un'immagine e quindi chiedo al BE di mandarmela. */
      if (this.image_for_viewer != null && this.image_for_viewer != "") {
        this.$viewerApi({
          options: {
            toolbar: true,
            url: "data-source",
            initialViewIndex: 0,
          },
          images: [{ "data-source": this.image_for_viewer }],
        });
      } else {
        const request = {
          controller: "Global",
          method: "POST",
          richiesta: {
            action: "getallegati",
            token: localStorage.user_token,
            id_riferimento: this.workorder.id_articolo,
            tipo: "ARTICOLO",
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            this.overlay = false;
            if (res.status === 200) {
              const res_tmp =
                res.data.result.allegati[res.data.result.allegati.length - 1];

              const request2 = {
                controller: "Global",
                method: "POST",
                richiesta: {
                  action: "getbase64bypath",
                  token: localStorage.user_token,
                  path:
                    localStorage.dbname +
                    "_ARTICOLO_" +
                    res_tmp.id_allegato +
                    "." +
                    res_tmp.estensione,
                },
              };

              this.$store
                .dispatch("api", request2)
                .then((res2) => {
                  this.overlay = false;
                  if (res2.status === 200) {
                    this.image_for_viewer = res2.data.result;

                    // L'immagine in alta definizione valorizza la mia variabile di supporto
                    this.$viewerApi({
                      options: {
                        toolbar: true,
                        url: "data-source",
                        initialViewIndex: 0,
                      },
                      images: [{ "data-source": this.image_for_viewer }],
                    });
                  } else {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                  }
                })
                .catch((e2) => {
                  console.error(e2);
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                  );
                });
            }
          })
          .catch((e) => {
            console.error(e);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          });
      }
    },
    transmitClickCheck(wo, cod_btn) {
      this.$emit("click_check", wo, cod_btn);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>